export default function Skeleton() {
  return (
    <div className="animate-pulse space-y-6">
      {/* Header */}
      <div className="space-y-2">
        <div className="h-6 w-48 bg-gray-200 rounded" />
        <div className="h-4 w-96 bg-gray-200 rounded" />
      </div>

      {/* Tracker */}
      <div className="h-20 bg-gray-200 rounded-lg" />

      {/* Filters */}
      <div className="flex flex-wrap gap-3">
        <div className="h-10 w-60 bg-gray-200 rounded-lg" />
        <div className="h-10 w-24 bg-gray-200 rounded-lg" />
        <div className="h-10 w-36 bg-gray-200 rounded-lg" />
        <div className="ml-auto h-10 w-36 bg-gray-300 rounded-lg" />
      </div>

      {/* Table */}
      <div className="border border-gray-200 rounded-lg overflow-hidden">
        <div className="bg-gray-100 p-4 grid grid-cols-4 gap-4">
          <div className="h-4 bg-gray-300 rounded" />
          <div className="h-4 bg-gray-300 rounded" />
          <div className="h-4 bg-gray-300 rounded" />
          <div className="h-4 bg-gray-300 rounded" />
        </div>

        {[...Array(3)].map((_, i) => (
          <div
            key={i}
            className="p-4 grid grid-cols-4 gap-4 border-t border-gray-200"
          >
            <div className="h-4 bg-gray-200 rounded w-20" />
            <div className="h-4 bg-gray-200 rounded w-40" />
            <div className="h-4 bg-gray-200 rounded w-28" />
            <div className="flex gap-2">
              <div className="h-8 w-8 bg-gray-200 rounded-lg" />
              <div className="h-8 w-8 bg-gray-200 rounded-lg" />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
